import Link from 'next/link';
import type { ElementType, SyntheticEvent } from 'react';
import Box from '@classify/react-core-components/Box';
import Tab from '@classify/react-core-components/Tab';
import Tabs from '@classify/react-core-components/Tabs';
import type { PolicySummary } from '../../types';
const LinkTab = Tab as ElementType;
type PoliciesTabBarProps = {
  getPolicyHref?: (policy: PolicySummary) => string;
  onChange: (event: SyntheticEvent, newId: string) => void;
  onPolicyClick?: (event: SyntheticEvent, policy: PolicySummary) => void;
  policies: PolicySummary[];
};
export default function PoliciesTabBar({
  getPolicyHref = policy => `./${policy.type}`,
  onChange,
  onPolicyClick,
  policies
}: PoliciesTabBarProps) {
  return <Box sx={{
    mt: 4
  }}>
      <Tabs variant="scrollable" scrollButtons onChange={onChange}>
        {policies.map((policy_0, index) => {
        const filteredTitle = policy_0.title.replace(/<\/?.*?>/g, '');
        return <LinkTab component={Link as ElementType} href={getPolicyHref(policy_0)} key={policy_0.type} label={filteredTitle} onClick={(event: SyntheticEvent) => onPolicyClick?.(event, policy_0)} value={String(index)} />;
      })}
      </Tabs>
    </Box>;
}